module.exports = "<footer class=\"app-footer\">\n  <span><a href=\"http://coreui.io/pro/\">CoreUI Pro</a> &copy; 2018 creativeLabs.</span>\n  <span class=\"ml-auto\">Powered by <a href=\"http://coreui.io/pro/\">CoreUI Pro</a></span>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/components/app-footer/app-footer.component.html
// module id = ../../../../../src/app/components/app-footer/app-footer.component.html
// module chunks = main